._quickEditComponentControlWrapper_1kup6_1 {
  width: 100%; }
